// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useEffect, useState } from 'react';
import Header from './Header';
import SearchCondition from './SearchCondition';
import ListResult from './ListResult';
import { ProductCard } from '../NewCard/types';
import { S } from './styles';
import { CardTypes, SearchCondition as SearchConditionTypes } from '../../types/Model';
import { KeywordTitle } from '../../redux/actionCreators/search/searchOnlineCoursesKeywordActions';

/**
 * This component renders OnlineCourseListPage and LabListPage
 */
interface SearchListComponentProps {
  /** list will be displayed as list results */
  list: ProductCard[];
  /** isFetching is used to hide list changes until it is falsy */
  isFetching: boolean;
  /** isMoreFetching is used to show loading animation when more result is being fetched */
  isMoreFetching: boolean;
  /** type is used to separate the type of list results */
  type: CardTypes;
  /** keywords will be displayed as list results */
  keywords: KeywordTitle[];
  /** commonkeywords will be displayed as list results when no keywords are available */
  commonKeywords: KeywordTitle[];
  /** updateListFilter is a function to update the filters for list result*/
  updateListFilter: (nextListFilter: SearchConditionTypes) => void;
  /** updateKeyword is a function to update current keyword for triggering recommendation api*/
  updateKeywordStream: (nextKeyword: string) => void;
  /** updatePage is a function to update current page for triggering more results api*/
  updatePage: () => void;
}

function SearchListComponent({
  isFetching,
  isMoreFetching,
  list,
  type,
  keywords,
  commonKeywords,
  updateListFilter,
  updateKeywordStream,
  updatePage,
  ...otherProps
}: SearchListComponentProps): JSX.Element {
  const [currentLevelId, setCurrentLevelId] = useState<number>(0);
  const [currentSelectedPlatformId, setCurrentSelectedPlatformId] = useState<number>(0);
  const [currentSelectedDomainIds, setCurrentSelectedDomainIds] = useState<number[]>([]);
  const [currentKeyword, setCurrentKeyword] = useState<string>('');

  useEffect(() => {
    updateListFilter({
      name: currentKeyword.length > 0 ? currentKeyword : undefined,
      levelId: currentLevelId !== 0 ? currentLevelId : undefined,
      platformId: currentSelectedPlatformId !== 0 ? currentSelectedPlatformId : undefined,
      domainIds: currentSelectedDomainIds
    })
  }, [currentKeyword, currentLevelId, currentSelectedPlatformId, currentSelectedDomainIds]);

  return (
    <S.Container {...otherProps}>
      <Header
        type={type}
        keywords={keywords}
        commonKeywords={commonKeywords}
        updateKeyword={setCurrentKeyword}
        updateKeywordStream={updateKeywordStream}
      />
      <S.Row>
        <SearchCondition
          selectedPlatformId={currentSelectedPlatformId}
          selectedDomainIds={currentSelectedDomainIds}
          updateSelectedPlatformId={setCurrentSelectedPlatformId}
          updateSelectedDomainIds={setCurrentSelectedDomainIds}
        />
        <ListResult
          isFetching={isFetching}
          isMoreFetching={isMoreFetching}
          list={list}
          type={type}
          currentKeyword={currentKeyword}
          updatePage={updatePage}
        />
        <S.LevelCondition levelId={currentLevelId} updateLevelId={setCurrentLevelId} />
      </S.Row>
    </S.Container>
  )
}

export { SearchListComponent as default };
